import React from 'react';
import ChangeTable from './ChangeTable';

const M365Docs = () => {
  return (
    <ChangeTable
      title="Recent Microsoft 365 Documentation Changes"
      dataSource="m365-changes.json"
      showGuideLink={false}
    />
  );
};

export default M365Docs;